var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEstimate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#1D95DC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37469 21.875C4.37469 12.6933 11.818 5.25 20.9997 5.25C30.1814 5.25 37.6247 12.6933 37.6247 21.875C37.6247 31.0567 30.1814 38.5 20.9997 38.5C11.818 38.5 4.37469 31.0567 4.37469 21.875ZM30.625 21.8747C30.625 16.5593 26.3163 12.2502 21.001 12.2497L21.0003 12.2497H21C20.5169 12.2499 20.1253 12.6415 20.1253 13.1247V21.8747C20.1253 22.3579 20.5171 22.7497 21.0003 22.7497C21.2118 22.7497 21.4057 22.6747 21.557 22.5498L27.125 29.2996C29.2626 27.5343 30.625 24.8636 30.625 21.8747Z",
    fill: "#1D95DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstimate);
export default __webpack_public_path__ + "static/media/icon-estimate.b8b747d2.svg";
export { ForwardRef as ReactComponent };